import { render, staticRenderFns } from "./RateTypesInfo.vue?vue&type=template&id=2b7a0f14"
import script from "./RateTypesInfo.vue?vue&type=script&lang=js"
export * from "./RateTypesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports